<template>
    <div v-if="props.activeNo == 1">
        <div class="table-container">
            <van-row class="table-header" type="flex" justify="space-between">
                <van-col span="8" class="table-data table-head">{{ $t('common.level') }}</van-col>
                <van-col span="8" class="table-data table-head">{{ $t('vip.betRequired') }}</van-col>
                <van-col span="8" class="table-data table-head">{{ $t('vip.bonus') }}</van-col>
            </van-row>
            <van-row v-for="(item, index) in props.tableData" class='table-row' :key="index" type="flex"
                justify="space-between" :style="{ background: Number(index) % 2 != 0 ? '#002121' : 'transparent' }">
                <van-col span="8" class="table-data" style="color: #f8e800;">
                    <div class="img-wrapper">
                        <img src="@/assets/themeFour/vip_level.png" alt="" />
                        <span class="img-text">{{ $t('vip.title') }}<span style="padding-left: 5px;">{{ item.level
                        }}</span></span>
                    </div>
                </van-col>
                <van-col span="8" class="table-data" style="color:#6b6f79;">
                    <div v-if="item.level == nextLevel">
                        {{ formatCurrency(item.bet_min) }}
                        <div class="bar">
                            <div class="progress"
                                :style="{ width: vipRewardInfo?.betTotal / nextLevelRecord?.bet_min < 1 ? vipRewardInfo?.betTotal * 100 / nextLevelRecord?.bet_min + '%' : '100%' }">
                            </div>
                            <div class="progress-end-dot"
                                :style="{ left: `calc(${vipRewardInfo?.betTotal * 100 / nextLevelRecord?.bet_min}% - 6px)` }">
                            </div>
                        </div>
                        <span style="color: #fff;">{{ vipRewardInfo?.betTotal + '/' + nextLevelRecord?.bet_min }}</span>
                    </div>
                    <div v-else>
                        {{ formatCurrency(item.bet_min) }}
                    </div>
                </van-col>
                <van-col span="8" class="table-data">{{ item.upgrade_bonus ? formatCurrency(item.upgrade_bonus) : '--'
                }}</van-col>
            </van-row>
            <NoData v-if="props.tableData.length <= 0" />
        </div>
    </div>
    <div v-if="props.activeNo == 2">
        <div class="table-container">
            <van-row class="table-header" type="flex" justify="space-between">
                <van-col span="12" class="table-data table-head">{{ $t('common.level') }}</van-col>
                <van-col span="12" class="table-data table-head">{{ $t('vip.dailyBonus') }}</van-col>
            </van-row>
            <van-row v-for="(item, index) in props.tableData" class='table-row' :key="index" type="flex"
                justify="space-between" :style="{ background: Number(index) % 2 != 0 ? '#1a1d22' : 'transparent' }">
                <van-col span="12" class="table-data" style="color: #f8e800;">
                    <div class="img-wrapper-tabs">
                        <img src="@/assets/themeFour/vip_level.png" alt="" />
                        <span class="img-text">{{ $t('vip.title') }}<span style="padding-left: 5px;">{{ item.level
                        }}</span></span>
                    </div>
                </van-col>
                <van-col span="12" class="table-data" v-if="activeData?.isDailyReward === 1">{{ item.daily_reward ?
                    formatCurrency(item.daily_reward) : '--' }}</van-col>
            </van-row>
            <NoData v-if="props.tableData.length <= 0" />
        </div>
    </div>
    <div v-if="props.activeNo == 3">
        <div class="table-container">
            <van-row class="table-header" type="flex" justify="space-between">
                <van-col span="12" class="table-data table-head">{{ $t('common.level') }}</van-col>
                <van-col span="12" class="table-data table-head">{{ $t('vip.weeklyBonus') }}</van-col>
            </van-row>
            <van-row v-for="(item, index) in props.tableData" class='table-row' :key="index" type="flex"
                justify="space-between" :style="{ background: Number(index) % 2 != 0 ? '#1a1d22' : 'transparent' }">
                <van-col span="12" class="table-data" style="color: #f8e800;">
                    <div class="img-wrapper-tabs">
                        <img src="@/assets/themeFour/vip_level.png" alt="" />
                        <span class="img-text">{{ $t('vip.title') }}<span style="padding-left: 5px;">{{ item.level
                        }}</span></span>
                    </div>
                </van-col>
                <van-col span="12" class="table-data" v-if="activeData?.isWeeklyRewards === 1">{{ item.week_reward ?
                    formatCurrency(item.week_reward) : '--' }}</van-col>
            </van-row>
            <NoData v-if="props.tableData.length <= 0" />
        </div>
    </div>
    <div v-if="props.activeNo == 4">
        <div class="table-container">
            <van-row class="table-header" type="flex" justify="space-between">
                <van-col span="12" class="table-data table-head">{{ $t('common.level') }}</van-col>
                <van-col span="12" class="table-data table-head">{{ $t('vip.monthlyBonus') }}</van-col>
            </van-row>
            <van-row v-for="(item, index) in props.tableData" class='table-row' :key="index" type="flex"
                justify="space-between" :style="{ background: Number(index) % 2 != 0 ? '#1a1d22' : 'transparent' }">
                <van-col span="12" class="table-data" style="color: #f8e800;">
                    <div class="img-wrapper-tabs">
                        <img src="@/assets/themeFour/vip_level.png" alt="" />
                        <span class="img-text">{{ $t('vip.title') }}<span style="padding-left: 5px;">{{ item.level
                        }}</span></span>
                    </div>
                </van-col>
                <van-col span="12" class="table-data" v-if="activeData?.isMonthlyRewards === 1">{{ item.month_reward ?
                    formatCurrency(item.month_reward) : '--'
                    }}</van-col>
            </van-row>
            <NoData v-if="props.tableData.length <= 0" />
        </div>
    </div>
    <div v-else-if="props.activeNo == 5">
        <div class="table-container">
            <van-row class="table-header" type="flex" justify="space-between">
                <van-col span="5" class="table-data table-head">{{ $t('common.level') }}</van-col>
                <van-col :span="spanSize" class="table-data table-head" v-if="activeData?.isDailyReward === 1">{{
                    $t('vip.dailyBonus')
                }}</van-col>
                <van-col :span="spanSize" class="table-data table-head" v-if="activeData?.isWeeklyRewards === 1">{{
                    $t('vip.weeklyBonus')
                }}</van-col>
                <van-col :span="spanSize" class="table-data table-head" v-if="activeData?.isMonthlyRewards === 1">{{
                    $t('vip.monthlyBonus')
                }}</van-col>
            </van-row>
            <van-row v-for="(item, index) in props.tableData" class='table-row' :key="index" type="flex"
                justify="space-between" :style="{ background: Number(index) % 2 != 0 ? '#1a1d22' : 'transparent' }">
                <van-col span="5" class="table-data" style="color: #f8e400;">
                    <div class="img-wrapper-lastTab">
                        <img src="@/assets/themeFour/vip_level.png" alt="" />
                        <span class="img-text">{{ $t('vip.title') }}<span style="padding-left: 5px;">{{ item.level
                        }}</span></span>
                    </div>
                </van-col>
                <van-col :span="spanSize" class="table-data" v-if="activeData?.isDailyReward === 1"
                    style="color:#6b6f79;">{{
                        formatCurrency(item.daily_reward_retention) }}</van-col>
                <van-col :span="spanSize" class="table-data" v-if="activeData?.isWeeklyRewards === 1">{{
                    formatCurrency(item.week_reward_retention) }}</van-col>
                <van-col :span="spanSize" class="table-data" v-if="activeData?.isMonthlyRewards === 1">{{
                    formatCurrency(item.month_reward_retention) }}</van-col>
            </van-row>
            <NoData v-if="props.tableData.length <= 0" />
        </div>
    </div>
</template>
<script setup lang="ts">
import NoData from '@/themes/themeFour/components/common/noData.vue';
import { formatCurrency } from '@/utils/commonFunction';
import { ref, computed } from 'vue';

const spanSize = computed(() => {
    let size = 0;
    const activeColCount = props.activeData?.isDailyReward + props.activeData?.isWeeklyRewards + props.activeData?.isMonthlyRewards;
    size = 18 / activeColCount
    return size;
});
const tabTopValue = computed(() => props.isTabView ? '55px' : '110px');
const props = defineProps({
    activeNo: {
        type: Number,
        required: true
    },
    tableData: {
        type: Array as () => any,
        required: false
    },
    activeData: {
        type: Object
    },
    vipRewardInfo: {
        type: Object
    },
    nextLevelRecord: {
        type: Object
    },
    nextLevel: {
        type: Number
    },
    isTabView: {
        type: Boolean
    }
})
</script>
<style scoped>
.table-row {
    padding: 12px 0;
    font-size: 14px;
    background: #ffffff0a;
    margin-bottom: 2px;
    align-items: center;
}

.table-data {
    align-items: center;
    text-align: center;
    color: #fba531;
    font-size: 14px;
    font-weight: 100;
    padding: 0px 5px;
}

.table-data img {
    width: 50px;
}

.table-head {
    color: #679291;
    font-weight: bold;
}

.table-container {
    background: transparent;
    /* border-radius: 12px; */
    /* max-width: 400px; */
    font-family: sans-serif;
    color: white;
    margin: 20px 15px 0;
}

.table-header {
    font-size: 14px;
    padding: 25px 0px;
    background: #024a49;
    align-items: center;
    position: sticky;
    top: v-bind(tabTopValue);
    z-index: 10;
    border-radius: 10px;
}

.bar {
    position: relative;
    background: #3b4152;
    border-radius: 10px;
    height: 4px;
    width: 100%;
    margin: 4px 0;
}

.progress {
    background: rgb(2, 74, 73);
    border-radius: 10px;
    height: 4px;
}

.progress-end-dot {
    position: absolute;
    top: 55%;
    transform: translateY(-50%);
    width: 4px;
    height: 4px;
    background-color: white;
    border-radius: 50%;
    z-index: 2;
}


.img-wrapper,
.img-wrapper-tabs,
.img-wrapper-lastTab {
    position: relative;
    display: inline-block;
    width: 100%;
}

.img-wrapper img {
    width: 90%;
    display: block;
}

.img-wrapper-tabs img {
    width: 70%;
}

.img-wrapper-lastTab img {
    width: 120%;
}

.img-text {
    position: absolute;
    top: 50%;
    left: 58%;
    transform: translate(-50%, -50%);
    color: #ffffff;
    white-space: nowrap;
    font-size: 14px;
    font-weight: bold;
}

.img-wrapper-lastTab .img-text {
    font-size: 12px;
    top: 45%;
    left: 75%;
}

@media (max-width: 450px) {
    .table-data {
        font-size: 14px;
    }

    .table-header {
        padding: 15px 0 !important;
    }
}
</style>